import { render } from "./basicView.vue?vue&type=template&id=ca17e44a"
import script from "./basicView.vue?vue&type=script&lang=js"
export * from "./basicView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__